import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';

const navItems = [
  { label: '首页', href: '#hero', isLink: false },
  { label: '热播排行', href: '#ranking', isLink: false },
  { label: '最新动态', href: '#updates', isLink: false },
  { label: '精选专题', href: '#carousel', isLink: false },
  { label: '剧集分类', href: '/category', isLink: true },
  { label: 'APP下载', href: '#app', isLink: false },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    setMobileOpen(false);
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-[72px] max-w-[1280px] mx-auto">
          <a
            href="#hero"
            onClick={(e) => handleNavClick(e, '#hero')}
            className="flex items-center gap-2 text-foreground-950 no-underline cursor-pointer"
          >
            <span className="w-9 h-9 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg font-heading text-lg">
              努
            </span>
            <span className="text-xl font-heading font-bold whitespace-nowrap">努努影院</span>
          </a>

          <nav className="hidden md:flex items-center gap-1">
            {navItems.map((item) =>
              item.isLink ? (
                <Link
                  key={item.href}
                  to={item.href}
                  className="px-4 py-2 text-sm text-foreground-700 hover:text-primary-500 rounded-md transition-colors duration-200 whitespace-nowrap cursor-pointer font-medium"
                >
                  {item.label}
                </Link>
              ) : (
                <a
                  key={item.href}
                  href={item.href}
                  onClick={(e) => handleNavClick(e, item.href)}
                  className="px-4 py-2 text-sm text-foreground-700 hover:text-primary-500 rounded-md transition-colors duration-200 whitespace-nowrap cursor-pointer font-medium"
                >
                  {item.label}
                </a>
              )
            )}
          </nav>

          <div className="hidden md:flex items-center gap-2">
            <Link
              to="/search"
              className="w-9 h-9 flex items-center justify-center text-foreground-600 hover:text-primary-500 rounded-full hover:bg-background-100 transition-colors cursor-pointer"
            >
              <i className="ri-search-line text-lg"></i>
            </Link>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700 cursor-pointer"
            aria-label="菜单"
          >
            <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-xl`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <nav className="md:hidden bg-background-50 border-t border-background-200 px-4 py-3">
          <div className="flex flex-col gap-1 max-w-[1280px] mx-auto">
            {navItems.map((item) =>
              item.isLink ? (
                <Link
                  key={item.href}
                  to={item.href}
                  onClick={() => setMobileOpen(false)}
                  className="px-4 py-3 text-sm text-foreground-700 hover:text-primary-500 hover:bg-background-100 rounded-md transition-colors cursor-pointer font-medium"
                >
                  {item.label}
                </Link>
              ) : (
                <a
                  key={item.href}
                  href={item.href}
                  onClick={(e) => handleNavClick(e, item.href)}
                  className="px-4 py-3 text-sm text-foreground-700 hover:text-primary-500 hover:bg-background-100 rounded-md transition-colors cursor-pointer font-medium"
                >
                  {item.label}
                </a>
              )
            )}
            <Link
              to="/search"
              onClick={() => setMobileOpen(false)}
              className="px-4 py-3 text-sm text-foreground-700 hover:text-primary-500 hover:bg-background-100 rounded-md transition-colors cursor-pointer font-medium"
            >
              搜索
            </Link>
          </div>
        </nav>
      )}
    </header>
  );
}